<template>
  <ViewContainer :px="6">
    <v-layout column justify-space-between fill-height>
      <component :is="tab" :email.sync="email" />

      <v-footer class="px-0">
        <v-row no-gutters class="px-0">
          <v-col class="mr-1">
            <v-btn
              block
              depressed
              class="white"
              height="52"
              :to="{ path: '/auth/find/password' }"
              id="btn__d/ylKoOEh06eNb2g60o5LQ=="
            >
              <b class="font-size--16">비밀번호 찾기</b>
            </v-btn>
          </v-col>
          <v-col>
            <BasicButton
              v-if="!showEmail"
              block
              depressed
              height="52"
              :disabled="!email"
              @click="next()"
            >
              <b class="font-size--16 color--white">확인</b>
            </BasicButton>
            <BasicButton
              v-else-if="email"
              block
              depressed
              height="52"
              :to="{ name: 'signin' }"
              id="btn__4/hlH/rLIUWLJIDlcnvwcA=="
            >
              <b class="font-size--16 color--white">로그인 하기</b>
            </BasicButton>
          </v-col>
        </v-row>
      </v-footer>
    </v-layout>
  </ViewContainer>
</template>

<script>
export default {
  data() {
    return {
      email: null,
      showEmail: false,
    }
  },
  computed: {
    tab() {
      const tab = this.showEmail ? 'Id' : 'Auth'
      return () => import(`@/components/auth/find/id/${tab}.vue`)
    },
  },
  methods: {
    next() {
      if (!this.email) return
      this.showEmail = true
    },
  },
}
</script>
